import styled from "styled-components";

export const Container = styled.div`
  /* display: grid;
    grid-template-columns: 24% 24% 24% 24%;
    grid-auto-rows: 30rem 20rem;
    grid-column-gap: 1%;
    width: 96%;
    min-height: 85vh;
    padding: 0 2%;
    background-color: #fff;
    padding-top: 2rem;
    @media only screen and (max-width: 867px) {
        grid-template-columns: 50% 50%; 
        grid-auto-rows: 60% 20rem;
    } */
`;
export const PosContainer = styled.div`
  width: 20%;
  height: 20%;
  background-color: red;
`;

export const Hero = styled.div`
  width: 100%;
  height: 200px;
  margin-bottom: 2rem;
  background: url("/assets/Hero-d.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  max-width: 1920px;
  @media only screen and (min-width: 768px) {
    height: 500px;
  }
`;

export const ArticleContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 96%;
  padding: 0 2%;
  background-color: #fff;
  padding-top: 2rem;
  a {
    text-decoration: none;
    width: 49%;
  }

  @media only screen and (min-width: 867px) {
    a {
      width: 24%;
    }
  }
`;
